export default __webpack_public_path__ + "static/media/HAFL.74f8a353.png";